import React from "react";

import { Link } from "@material-ui/core";

export default function Imprint({ ...props }) {
  return (
    <>
      <section className="imprint carticle carticle--padded">
        <h2>Information in accordance with §5 TMG:</h2>
        <article>
          Alexander Bienzeisler
          <br />
          Windorfer Str. 7<br />
          04229 Leipzig
        </article>
        <h2>Contact Information</h2>
        <article>
          Telephone:{" "}
          <Link href="tel:+4917621227893" color="secondary">
            +4917621227893
          </Link>
          <br />
          E-Mail:{" "}
          <Link href="mailto:contact@metalstreams.tv" color="secondary">
            contact@metalstreams.tv
          </Link>
          <br />
          Internet address:{" "}
          <Link
            href={process.env.REACT_APP_BASE_URL}
            target="_blank"
            color="secondary"
          >
            metalstreams.tv
          </Link>
        </article>
        <h2>Disclaimer</h2>
        <h3>Accountability for content</h3>
        <article>
          The contents of our pages have been created with the utmost care.
          However, we cannot guarantee the contents' accuracy, completeness or
          topicality. According to statutory provisions, we are furthermore
          responsible for our own content on these web pages. In this matter,
          please note that we are not obliged to monitor the transmitted or
          saved information of third parties, or investigate circumstances
          pointing to illegal activity. Our obligations to remove or block the
          use of information under generally applicable laws remain unaffected
          by this as per §§ 8 to 10 of the Telemedia Act (TMG).
        </article>

        <h3>Accountability for links</h3>
        <article>
          Responsibility for the content of external links (to web pages of
          third parties) lies solely with the operators of the linked pages. No
          violations were evident to us at the time of linking. Should any legal
          infringement become known to us, we will remove the respective link
          immediately.
        </article>

        <h3>Copyright</h3>
        <article>
          Our web pages and their contents are subject to German copyright law.
          Unless expressly permitted by law, every form of utilizing,
          reproducing or processing works subject to copyright protection on our
          web pages requires the prior consent of the respective owner of the
          rights. Individual reproductions of a work are only allowed for
          private use. The materials from these pages are copyrighted and any
          unauthorized use may violate copyright laws.
        </article>

        <h3>Additional Information</h3>
        <article>
          <i>Thanks to: </i>
          <Link
            href="http://www.translate-24h.de"
            target="_blank"
            rel="noopener noreferrer"
            color="secondary"
          >
            translate-24h.de English Translations
          </Link>
        </article>
      </section>
    </>
  );
}
